import { c as _c } from "react/compiler-runtime";
import { useGetBulkDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-helper";
import { TEAM_DISPLAY_NAME } from "@src/constants/team-constants";
import { useAppSelector } from "@store/store-helper";
import { bulkActionResultsSelector, numberOfUpdatingItemsSelector } from "@store/table/table-selector";
import { nounPluralize } from "@utils/data-display";

/** Determines the content of the bulk dialog and the bulk success dialog for adding members to a team */
export function useAddToTeamBulkDialogContent() {
  const $ = _c(14);
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const {
    numberOfSuccess
  } = useAppSelector(bulkActionResultsSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      title: `Add members to ${TEAM_DISPLAY_NAME}`,
      description: `Select a ${TEAM_DISPLAY_NAME} to add the following members to.`
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== numberOfUpdatingItems) {
    t1 = nounPluralize({
      counter: numberOfUpdatingItems,
      word: "this",
      shouldShowCounter: false
    });
    $[1] = numberOfUpdatingItems;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== numberOfUpdatingItems) {
    t2 = nounPluralize({
      counter: numberOfUpdatingItems,
      word: "member",
      shouldShowCounter: false
    });
    $[3] = numberOfUpdatingItems;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = `${t1} ${t2} couldn't be added to the ${TEAM_DISPLAY_NAME}, check the details and try again.`;
  let t4;
  if ($[5] !== t3) {
    t4 = {
      initial: t0,
      failed: {
        title: `Couldn't add members to ${TEAM_DISPLAY_NAME}`,
        description: t3
      },
      confirmButtonText: "add",
      entityType: "member"
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const bulkDialogContent = useGetBulkDialogContent(t4);
  let t5;
  if ($[7] !== numberOfSuccess) {
    t5 = nounPluralize({
      counter: numberOfSuccess,
      word: "member"
    });
    $[7] = numberOfSuccess;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `${t5} ${numberOfSuccess === 1 ? "was" : "were"} added to the ${TEAM_DISPLAY_NAME}.`;
  let t7;
  if ($[9] !== t6) {
    t7 = {
      title: `Members added to ${TEAM_DISPLAY_NAME}`,
      description: t6
    };
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const successDialogContent = t7;
  let t8;
  if ($[11] !== bulkDialogContent || $[12] !== successDialogContent) {
    t8 = {
      bulkDialogContent,
      successDialogContent
    };
    $[11] = bulkDialogContent;
    $[12] = successDialogContent;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}